import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { AccessibilityText } from '@glu/utilities-react';
import { darkModeAware, withStyles } from '@glu/theming';
import locale from '@glu/locale';
import styles from './LabelText.styles';

const propTypes = {
  /** JSS classes for checkbox styling (empty object with BareCheckbox) */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  /** Label text to use for label */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  /** Additional class to add to label */
  className: PropTypes.string,
  /** Determines if this label should be screen reader only */
  screenReaderLabel: PropTypes.bool,
  /** Shows LabelText in red if true (used in styles) */
  hasError: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  /** Shows optional text on label */
  optional: PropTypes.bool,
  /** Add data-qa to the label */
  dataQa: PropTypes.string,
  /** Boolean to indicate whether or not you want the standard inline layout */
  inline: PropTypes.bool,
  /** Boolean to indicate whether the label is being used with a textarea */
  /* eslint-disable-next-line react/no-unused-prop-types */
  textarea: PropTypes.bool
};

const defaultProps = {
  className: '',
  screenReaderLabel: false,
  hasError: false,
  optional: false,
  dataQa: '',
  inline: false,
  textarea: false
};

const LabelText = ({
  classes,
  label,
  className,
  optional,
  screenReaderLabel,
  dataQa,
  inline
}) => {
  const optionalText = useMemo(() => {
    if (optional && !inline) {
      return <span className={classes.optional}>{locale.get('optional')}</span>;
    }

    return null;
  }, [classes.optional, inline, optional]);

  if (screenReaderLabel) {
    return (
      <AccessibilityText>{label}</AccessibilityText>
    );
  }
  return (
    <p className={`${classes.root} ${className}`} data-qa={dataQa}>
      {label}
      {optionalText}
    </p>
  );
};

LabelText.propTypes = propTypes;
LabelText.defaultProps = defaultProps;

export const BareLabelText = LabelText;
const DarkStyledLabel = darkModeAware(withStyles(styles)(LabelText));
DarkStyledLabel.displayName = 'Label';
export default DarkStyledLabel;
